
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_204_41)"}},[_c('path',{attrs:{"d":"M15.785.346h1.932v3.068c3.643.02 7.29-.038 10.93.016.784-.074 1.397.535 1.319 1.32.058 6.366-.014 12.735.034 19.105-.034.689.068 1.452-.327 2.062-.498.361-1.145.314-1.728.34-3.408-.016-6.816-.01-10.228-.01v3.409h-2.12C10.403 28.708 5.2 27.843.002 26.929c-.004-7.95 0-15.902 0-23.85C5.26 2.17 10.519 1.243 15.785.346z","fill":"#D24625"}}),_c('path',{attrs:{"d":"M17.717 4.436h11.247v20.79H17.717v-2.727h8.18v-1.363h-8.18v-1.704h8.18v-1.363H17.72l-.006-2.004c1.35.419 2.886.409 4.093-.403 1.305-.773 1.987-2.25 2.1-3.722-1.497-.01-2.993-.006-4.486-.006-.003-1.483.017-2.965-.03-4.445-.56.11-1.118.225-1.674.345V4.435z","fill":"#fff"}}),_c('path',{attrs:{"d":"M20.106 6.777c2.369.11 4.359 2.103 4.485 4.465-1.496.017-2.992.01-4.489.01 0-1.492-.003-2.985.004-4.475z","fill":"#D24625"}}),_c('path',{attrs:{"d":"M5.468 9.35c1.85.09 4.093-.732 5.627.655 1.469 1.782 1.08 5.06-1.097 6.128-.774.395-1.66.34-2.502.313-.004 1.333-.007 2.665-.004 3.998-.675-.058-1.351-.115-2.028-.17A559.4 559.4 0 015.468 9.35z","fill":"#fff"}}),_c('path',{attrs:{"d":"M7.492 11.194c.672-.03 1.504-.153 1.957.478.389.668.368 1.547.044 2.235-.388.703-1.268.634-1.946.716-.072-1.142-.065-2.284-.055-3.428z","fill":"#D24625"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_204_41"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h30v30H0z"}})])])])
          )
        }
      }
    